import ResourceList from '../../components/ResourceList';
import React from 'react';
import {connect} from 'react-redux';
import {toArray} from '../../util/idMap';
import {LoadLocationUsersEpic,AddLocationUserEpic} from '../../actions/users.actions';
import CircularProgress from 'material-ui/CircularProgress'
import AddUserForm from './AddUserForm';
import {CardActions} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import { withRouter } from 'react-router-dom'

class LocationUsers extends React.Component {

  constructor(props){
    super();
    this.state = {
      showAddDialog: false
    }
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.createUser = this.createUser.bind(this);
  }

  handleDialogClose() {
    this.setState({showAddDialog:false});
  }

  createUser(userRecord) {
    console.log(userRecord);
    this.props.addNewUser(this.props.location.iqParentEntityId, this.props.locationId, userRecord);
    this.setState({showAddDialog:false});
  }

  componentDidMount() {
    if (this.props.location) {
      this.props.loadUsers(this.props.location.iqParentEntityId, this.props.locationId);
    }
  }

  getColumns() {
    return [
      {name: 'FirstName', label: 'First Name'},
      {name: 'LastName', label: 'Last Name'},
      {name: 'UserName', label: 'Username'},
      {name: 'Email', label: 'Email'},
    ];
  }

  render() {
    return (
      <div>
        <CardActions>
          <FlatButton label="Add User" primary={true} onClick={()=>this.setState({showAddDialog: true})}/>
        </CardActions>
        <ResourceList columns={this.getColumns()} data={this.props.users}/>
        {this.props.loading? <div style={{textAlign: 'center'}}><CircularProgress/></div> : null }
        {this.state.showAddDialog? <AddUserForm model={{}} onSubmit={this.createUser} onClose={this.handleDialogClose} show={this.state.showAddDialog}/>:null}
      </div>
      
    );
  }

}

const mapStateToProps = ({usersEndpoint, authEndpoint, companiesEndpoint, locationsEndpoint},{match}) => ({
  loading: usersEndpoint.fetchInProgress,
  loadingError: usersEndpoint.fetchError,
  users: toArray(usersEndpoint.users),
  company: match.params.companyId? companiesEndpoint.companies[match.params.companyId] : null,
  companyId: authEndpoint.companyId,
  location: locationsEndpoint.locations[match.params.locationId],
});

const mapDispatchToProps = (dispatch) => ({
  loadUsers: (companyId, locationId) => dispatch(LoadLocationUsersEpic(companyId, locationId)),
  addNewUser: (companyId, locationId, user) => dispatch(AddLocationUserEpic(companyId, locationId, user))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LocationUsers));


// WEBPACK FOOTER //
// ./src/containers/Locations/LocationUsers.js